import { T } from "../../constants/theme";

export default function ExploreHeader({ stats }) {
  const items = [
    { label: "Products", value: stats.totalProducts },
    { label: "Brands", value: stats.totalBrands },
    { label: "Categories", value: stats.totalCategories },
  ];

  return (
    <div style={{ textAlign: "center", padding: "56px 20px 32px" }}>
      <div
        style={{
          fontSize: 11,
          letterSpacing: ".3em",
          textTransform: "uppercase",
          color: T.gold,
          fontWeight: 700,
          marginBottom: 14,
        }}
      >
        Search • Filter • Compare • Save
      </div>
      <h1
        style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontSize: "clamp(32px, 5vw, 52px)",
          margin: "0 0 14px",
          color: T.ink,
          letterSpacing: "-.01em",
        }}
      >
        Explore Products
      </h1>
      <p
        style={{
          maxWidth: 620,
          margin: "0 auto 28px",
          color: T.inkSoft,
          fontSize: 16,
          lineHeight: 1.7,
        }}
      >
        Browse every product in our farm & garden marketplace. Search,
        filter, and discover what's right for what you're growing.
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 28,
          flexWrap: "wrap",
        }}
      >
        {items.map((item) => (
          <div key={item.label} style={{ textAlign: "center" }}>
            <div style={{ fontSize: 24, fontWeight: 800, color: T.ink }}>
              {item.value}
            </div>
            <div
              style={{
                fontSize: 11,
                letterSpacing: ".18em",
                textTransform: "uppercase",
                color: T.muted,
                marginTop: 4,
              }}
            >
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
